export const enum FeedbackTypeEnum {
  EMPTY = 'empty',
  BUG = 'bug',
  QUESTION = 'question',
  COMMENT = 'comment',
  SUGGESTION = 'suggestion',
}
